import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { DEVICES, SIZES } from '../../constants'
import { RegularCol, RegularRow } from '../utils/Grid'
import Headline from '../utils/Headline'
import MoreLink from '../utils/MoreLink'
import MoreButton from '../utils/MoreButton'

const WrapperRow = styled(RegularRow)`
  display: -ms-flexbox;
  border: 0;
  min-height: 39px;
  position: relative;
`

const ChildrenWrapper = styled.div`
  margin-bottom: ${props => props.isOpen ? '39px' : '0'};
  margin-top: 39px;
  overflow: ${props => props.isOpening ? 'hidden' : 'none'};
  position: relative;
  transition: all ease 0.2s;
  width: 100%;
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin-bottom: 0;
  }
`

const Children = styled.div`
  margin-bottom: ${props => props.isOpen ? '0' : '-100%'};
  transition: all ease 0.2s;
`

const Separator = styled.div`
  background: #fff;
  bottom: 0;
  height: 25px;
  left: 0;
  position: absolute;
  right: 0;
`

const Line = styled.div`
  border-top: 1px solid #d1d1d1;
  height: 1px;
  position: absolute;
  width: 100%;
`

const Toggler = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  cursor: pointer;
  font-size: 10px;
  color: #1359c3;
  text-align: center;
`

const ToggleIconWrapper = styled.div`
  background: #fff;
  margin: 0 auto;
  margin-bottom: ${props => props.isOpen ? '0' : '3px'};
  margin-top: ${props => props.isOpen ? '-1px' : '-6px'};
  width: 26px;
  z-index: 1;
`

const ToggleIcon = styled.div`
  display: block;
  width: 7px;
  height: 7px;
  border-left: 1px solid #1359c3;
  border-top: 1px solid #1359c3;
  transform: ${props => props.isOpen ? 'rotate(45deg)' : 'rotate(225deg)'};
  margin: 0 auto;
`

class WidgetContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: true
    }

    this.handleToggleContent = this.handleToggleContent.bind(this)
  }

  handleToggleContent () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const {
      isOpen
    } = this.state
    const {
      activeSection,
      children,
      headlineContent,
      isOpening,
      showBottomLine,
      widget,
      widget: {
        device,
        name
      }
    } = this.props

    return (
      <WrapperRow id={name}>
        <RegularCol sm={12}>
          <Headline isActive={isOpen} widget={widget}>
            { headlineContent }
            { device !== DEVICES.MOBILE && isOpen && <MoreLink widget={widget} activeSection={activeSection}/> }
          </Headline>
          <ChildrenWrapper isOpen={isOpen} isOpening={isOpening}>
            <Children isOpen={isOpen}>
              { children }
            </Children>
            { device === DEVICES.MOBILE && <MoreButton widget={widget} activeSection={activeSection}/> }
          </ChildrenWrapper>
          { device !== DEVICES.MOBILE && showBottomLine &&
            <Separator>
              <Line/>
              { isOpening &&
                <Toggler onClick={this.handleToggleContent}>
                  <ToggleIconWrapper isOpen={isOpen}>
                    <ToggleIcon isOpen={isOpen}/>
                  </ToggleIconWrapper>
                  <div>
                    { isOpen ? 'Skrýt' : 'Zobrazit' }
                  </div>
                </Toggler>
              }
            </Separator>
          }
        </RegularCol>
      </WrapperRow>
    )
  }
}

WidgetContainer.propTypes = {
  activeSection: PropTypes.number,
  children: PropTypes.node.isRequired,
  headlineContent: PropTypes.node,
  isOpening: PropTypes.bool,
  showBottomLine: PropTypes.bool,
  widget: PropTypes.object.isRequired
}

WidgetContainer.defaultProps = {
  activeSection: 0,
  isOpening: false,
  showBottomLine: true
}

export default WidgetContainer
